import Fingerprint2 from 'fingerprintjs2';
import OssApi from '@/api/PcModule/oss';
import { ElMessage } from 'element-plus';

/**
 * 公共工具函数文件
 */

/**
 * route.params.xxx的值若包含.html则去掉。比如 ：route.params.id = 123456789.html，则把.html去掉，返回123456789
 * @param str 包含.html的字符串
 * @returns 
 */
export const deleteHtml = (str: string) => {
    if (str.indexOf('.') !== -1) {
        return str.substring(0, str.indexOf('.'))
    }
    return str;
}

/**
 * 
 * @param url 被打开的url
 */
export const openUrl = (url: string) => {
    const host = window.location.host;
    if (!host.includes('www')) {
        url = url.replace('.html', '');
    } else {
        url = url.replace(import.meta.env.VITE_WWW_HOST, '');
    }
    window.open(url);
}

/**
 * 被匹配的字符串的某个字符高亮， 比如字符串是：val = 你好，keyword = 好，则“好”高亮显示
 * @param val 原字符串
 * @param keyword 字符串的某个字符
 * @returns 
 */
export const brightenKeyword = (val: string, keyword: string) => {
    const Reg = new RegExp(keyword, 'i');
    if (val) {
        return val.replace(Reg, `<span style="color: #409EFF; font-size:14px;">${keyword}</span>`);
    }
}

/**
 * 判断时间是否过去15天
 * @param dateString 时间字符串，格式：2024-04-06 11:34:00
 */
export const hasPassedFifteenDays = (dateString: string) => {
    dateString = dateString?.replace(/-/g, '/');
    const orderTime = new Date(dateString).getTime();
    const nowTime = Date.now();
    return nowTime - orderTime > 86400000 * 15;
}   

/**
 * 判断当前访问的设备是否是移动端
 */
export const isMobileDevice = () => {    
    const userAgent = navigator.userAgent;  
    const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;  
    return mobileRegex.test(userAgent.toLowerCase());  
} 

/**
 * 生成随机字符串
 * @param {number} length - 字符串长度 
 * @param {string} charset - 可选字符集
 * @returns {string} 随机字符串
 * randomString(10) // 默认10位字母数字组合
 * randomString(6, '012345') // 6位数字验证码
 */

export const randomString = (length = 8, charset = '') =>{
    const baseChars = charset || 
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const values = new Uint32Array(length);
      crypto.getRandomValues(values);
      for (let i = 0; i < length; i++) {
        result += baseChars[values[i] % baseChars.length];
      }
    } 
    else {
      for (let i = 0; i < length; i++) {
        result += baseChars.charAt(
          Math.floor(Math.random() * baseChars.length)
        );
      }
    }
    
    return result;
  }
  
  // 获取applyId函数，用于上传图片到oss用
export const getApplyId = (callback) => {
  // 获取浏览器指纹
  function generateBrowserFingerprint(callback) {
      Fingerprint2.get(async function (components) {
          const values = components.map(function (component, index) {
              if (index === 0) {
                  return component.value.replace(/\bNetType\/\w+\b/, '')
              }
              return component.value
          })
          callback(Fingerprint2.x64hash128(values.join(''), 31));
      })
  };
  generateBrowserFingerprint(async function(browserFingerValue) {
      const res: any = await OssApi.uploadFileApply({
          sign: browserFingerValue
      });
      if (res.code == 200 && res.data?.applyId) {
        callback({
          sign: browserFingerValue,
          applyId: res.data?.applyId
        });
      } else {
          ElMessage.error(res.message);
      }
  })
}
